/**
 * Utility for interacting with browser localStorage with JSON serialization.
 */
export const StorageUtil = {
  /**
   * Retrieves a value from localStorage and parses it as JSON.
   *
   * @template T
   * @param {string} key - The storage key to retrieve.
   * @returns {T | null} The parsed value if present, otherwise null.
   */
  get<T>(key: string): T | null {
    const value = localStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : null;
  },

  /**
   * Serializes a value to JSON and stores it in localStorage.
   *
   * @template T
   * @param {string} key - The storage key under which to save the value.
   * @param {T} value - The value to serialize and store.
   */
  set<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  },

  /**
   * Removes an entry from localStorage.
   *
   * @param {string} key - The storage key to remove.
   */
  remove(key: string): void {
    localStorage.removeItem(key);
  },
};
